export const ARTICLE_ENHANCEMENT_MAIN_TITLE = "Enrichir l'article";
